/**
 * The function return time zone offset in format "+0200"
 */
export function getCurrentTimeZoneOffset(date = new Date()): string {
  return (date.toString().match(/([-\+][0-9]+)\s/) || [])[1];
}
